// CacheKey d9a7c6d31e83b4bd69185fa030d12888
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-PAYER": {
    data_view: {
      default_name: {
        workflows: "Workflows"
      },
      headers: {
        defaults: {
          enrollment: {
            workflows: "Workflows"
          },
          workflow: {
            name: "Workflow"
          },
          patient: {
            tags: "Tags"
          }
        },
        workflows_view: {
          patient: {
            name: "Member"
          }
        }
      }
    }
  }
}

